module.exports = __webpack_public_path__ + "static/media/map-pin-filled.8badcdac.svg";